module.exports = __webpack_public_path__ + "img/mainSlope.82fdf160.svg";